import React, { useState } from "react";
import { useBotStore } from "../../stores/botStore";
import { infoIcon } from "assets";
import { ToggleFilterCheckbox, InfoModal, Icon } from "components";
import ManagerSettingsModal from "./ManagerSettingsModal";
import { formatUah } from "utils/format";

// Компонент таблиці менеджерів
const ManagersTable = () => {
  // Отримуємо необхідні дані та дії зі стору
  const managers = useBotStore((state) => state.managers);
  const managersFilters = useBotStore((state) => state.managersFilters);
  const isManagersLoading = useBotStore((state) => state.isManagersLoading);
  const updateManagerStatus = useBotStore((state) => state.updateManagerStatus);
  const setManagersFilter = useBotStore((state) => state.setManagersFilter);
  const setSort = useBotStore((state) => state.setSort);

  // Локальні стейти
  const [editingManager, setEditingManager] = useState(null);

  // Відображення стрілочки сортування
  const getSortIndicator = (columnKey) => {
    if (managersFilters.sort_by !== columnKey) return "";
    return managersFilters.sort_order === "asc" ? " ▲" : " ▼";
  };

  // Зміна статусу (Online/Offline)
  const handleStatusToggle = async (manager) => {
    await updateManagerStatus(manager.manager_id, !manager.is_online);
  };

  // Формування масиву даних для InfoModal
  const getTotalsInfo = (manager) => {
    const totals = manager.totals || {};
    return [
      {
        label: "Загальна сума",
        value: formatUah(totals.total_sum),
      },
      {
        label: "Онлайн цикли",
        value: totals.online_cycles || "0",
      },
      {
        label: "Кількість замовлень",
        value: totals.order_count || "0",
      },
    ];
  };

  return (
    <div id="managers-table" className="botsettings-table">
      <div className="table-title">
        <h4>Менеджери</h4>
        <ToggleFilterCheckbox
          id="managers-online-filter"
          label="Тільки онлайн"
          checked={managersFilters.is_online === 1}
          onChange={(e) => setManagersFilter("is_online", e.target.checked ? 1 : null)}
        />
      </div>

      <table className={`${isManagersLoading ? "table-loading" : ""}`}>
        <thead>
          <tr>
            <th
              onClick={() => setSort("manager_id")}
              className="clickable"
              title="Сортувати за ID"
            >
              ID{getSortIndicator("manager_id")}
            </th>
            <th
              onClick={() => setSort("manager_name")}
              className="clickable"
              title="Сортувати за ім'ям"
            >
              Менеджер{getSortIndicator("manager_name")}
            </th>
            <th
              onClick={() => setSort("is_online")}
              className="clickable"
              title="Сортувати за статусом"
            >
              Статус{getSortIndicator("is_online")}
            </th>
            <th
              onClick={() => setSort("weighted_score")}
              className="clickable"
              title="Сортувати за показником"
            >
              Зважений показник{getSortIndicator("weighted_score")}
            </th>
            <th className="actions-col">Дії</th>
          </tr>
        </thead>
        <tbody>
          {managers.length === 0 && !isManagersLoading ? (
            <tr>
              <td colSpan="5" className="empty-row">
                Немає менеджерів
              </td>
            </tr>
          ) : (
            managers.map((manager) => (
              <tr key={manager.manager_id}>
                <td>{manager.manager_id}</td>
                <td>{manager.manager_name}</td>
                <td
                  onDoubleClick={() => handleStatusToggle(manager)}
                  title="Подвійний клік для зміни статусу"
                >
                  <span
                    className={`manager-status clickable ${manager.is_online ? "online" : "offline"}`}
                  >
                    {manager.is_online ? "В мережі" : "Не в мережі"}
                  </span>
                </td>
                <td>
                  <InfoModal info={getTotalsInfo(manager)}>
                    <span>{manager.weighted_score?.toFixed(2) ?? "-"}</span>
                  </InfoModal>
                </td>
                <td className="actions-cell actions-col">
                  <button
                    className="icon-btn"
                    onClick={() => setEditingManager(manager)}
                    title="Налаштування"
                  >
                    <Icon src={infoIcon} />
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {editingManager && (
        <ManagerSettingsModal
          manager={editingManager}
          onClose={() => setEditingManager(null)}
        />
      )}
    </div>
  );
};

export default ManagersTable;
